import { Component, Input, OnInit, OnChanges, HostBinding, EventEmitter, Output, SimpleChanges } from '@angular/core';
import { QueryCondition } from '../../entity/querycondition';
import { ControlType } from '../../entity/controltype';
import { DropDownControl } from '../../entity/controltype/dropdownlist/dropdowncontrol';
import { EnumType } from '../../entity/controltype/dropdownlist/enumtype';
import { EnumIntegerValue } from '../../entity/controltype/dropdownlist/integerenumvalue';
import { EnumStringValue } from '../../entity/controltype/dropdownlist/stringenumvalue';
import { EnumBoolValue } from '../../entity/controltype/dropdownlist/boolenumvalue';
import { SolutionService } from '../../service/solution.service';
import { DropDownListValue } from '../../entity/conditionvalue/dropdownlistvalue';

@Component({
    selector: 'app-filter-dropdown',
    templateUrl: './dropdown.component.html'
})

export class DropDownComponent implements OnInit, OnChanges {

    /**
     * QueryCondition类型
     */
    @Input() item: any;
    @Input() autoLabel: boolean;
    @Input() disabled: boolean;
    @Input() editable = false;
    @Input() enableClear = true;
    @Output('searchHandle') searchHandle = new EventEmitter();

    dropDownListDataSource: Array<any> = new Array<any>();
    /**判断是否是在扩展区域展示 */
    extend: boolean = false;
    /**判断是否显示label */
    showlabel: boolean = true;

    selectedItemId: any;
    placeholder: string;


    @HostBinding('class.filter-item-wrap')
    get isExtend(): boolean {
        return !this.extend && this.autoLabel;
    }
    @HostBinding('class.filter-item-hiddenlabel')
    get hidenLabel(): boolean {
        return !this.showlabel;
    }
    /**
    * 某个字段发生值变化事件时，需要同步清空的字段，可能不是当前字段
    */
    @Input() changeFields: Array<string> = [];
    constructor(private solutionService: SolutionService) { }

    ngOnInit(): void {
        // this.getDataSource();
        // const initialValue = this.item.value as DropDownListValue;
        // initialValue.value && (this.selectedItemId = initialValue.value.getEnumValue());
        if (this.item) {
            const type = Object.prototype.toString.call(this.item.placeHolder);
            if (type == '[object Undefined]') {
                if (this.item.control && this.item.control.hasOwnProperty('placeholder')) {
                    this.placeholder = this.item.control.placeholder;
                }
            }
            else {
                this.placeholder = this.item.placeHolder;
            }

            if (this.item.control && this.item.control.hasOwnProperty('editable')) {
                this.editable = this.item.control.editable;
            }

        }
        this.getDataSource();
        const initialValue = this.item.value as DropDownListValue;
        initialValue.value && (this.selectedItemId = initialValue.value);
        if (this.item && this.item.control) {
            if (this.item.control.hasOwnProperty('isExtend')) {
                this.extend = this.item.control.isExtend;
                if (!this.extend) {
                    this.showlabel = this.item.control.showLabel;
                }
            }
        }

        this.solutionService.addFilterEditorInstance(this.item.fieldCode, this);


        (this.item.value as DropDownListValue).clear$.subscribe(() => {
            this.selectedItemId = '';
        });
        // this.testId = this.solutionService.getGuid();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.getDataSource();
        if(changes['changeFields'] && changes['changeFields'].currentValue && !changes['changeFields'].firstChange) {
            const isChange = changes['changeFields'].currentValue.some(field => field == this.item.fieldCode);
            if(isChange){
                this.selectedItemId = (this.item.value as DropDownListValue).value;
            }
        }
        //console.log(this.dropDownListDataSource);
    }

    getDataSource() {
        if (this.item && this.item.value
            && this.item.control && this.item.control.getControlType() == ControlType.DropDown) {
            let dropDownList = (this.item.control as DropDownControl);
            if (dropDownList.valueType == EnumType.BoolType) {
                this.dropDownListDataSource = Array<EnumBoolValue>();
                if (dropDownList.enumValues && dropDownList.enumValues.length > 0) {
                    dropDownList.enumValues.forEach(element => {
                        this.dropDownListDataSource.push(Object.assign(new EnumBoolValue(), element));
                    });
                }
            }
            else if (dropDownList.valueType == EnumType.IntType) {
                this.dropDownListDataSource = Array<EnumIntegerValue>();
                if (dropDownList.enumValues && dropDownList.enumValues.length > 0) {
                    dropDownList.enumValues.forEach(element => {
                        this.dropDownListDataSource.push(Object.assign(new EnumIntegerValue(), element));
                    });
                }
            }
            else if (dropDownList.valueType == EnumType.StringType) {
                this.dropDownListDataSource = Array<EnumStringValue>();
                if (dropDownList.enumValues && dropDownList.enumValues.length > 0) {
                    dropDownList.enumValues.forEach(element => {
                        this.dropDownListDataSource.push(Object.assign(new EnumStringValue(), element));
                    });
                }
            }
        }
    }

    // getConditionItemStyle(field: QueryCondition, controlType: any) {
    //     return this.solutionService.getConditionItemStyle(field,controlType);
    // }

    getConditionItemTitle(field: QueryCondition) {
        return this.solutionService.getConditionItemTitle(field);
    }

    onSearch(event) {
        if (event) {
            (this.item.value as DropDownListValue).value = event.data.value;
        } else {
            (this.item.value as DropDownListValue).value = '';
        }

        if (this.disabled) { return; }
        this.searchHandle.emit();
    }

    onClear(event) {
        (this.item.value as DropDownListValue).value = '';
        this.searchHandle.emit();
    }
}
